/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { UsersApi } from "@/api/users";
import { DataProvider } from "react-admin";
import { ResourceName } from "../react-admin.util";

const dataProvider: DataProvider = {
  getList: async (_, params) => {
    const { pagination, sort, filter } = params;

    const users = await UsersApi.getUsers({
      ...filter,
      page: pagination?.page,
      perPage: pagination?.perPage,
      sortBy: sort?.field,
      sortDirection: sort?.order.toLowerCase(),
    });

    return { data: users.data, total: users.meta.total };
  },
  getMany: () => {
    return new Promise((res) => res);
  },
  getOne: async (_, params) => {
    const { id } = params;

    const user = await UsersApi.getUser({ userId: id });

    return { data: user };
  },
  create: () => {
    return new Promise((res) => res);
  },
  update: () => {
    return new Promise((res) => res);
  },
  updateMany: () => {
    return new Promise((res) => res);
  },
  delete: () => {
    return new Promise((res) => res);
  },
  deleteMany: () => {
    return new Promise((res) => res);
  },
  getManyReference: () => {
    return new Promise((res) => res);
  },
};

export const usersResourceProvider = {
  resource: ResourceName.USERS,
  dataProvider,
};
